import React, {useContext, useEffect, useState} from 'react'
import {withRouter} from 'react-router-dom'
import {Page_settings} from '../../config/page_settings'
import strings from '../../lang/strings'
import {observer} from 'mobx-react'
import SidebarLeft from '../../components/sidebar/sidebar_left'
import PageSubHeader from '../../components/common/page_sub_header'
import {MenuMy} from '../../config/page_route'
import {formatNumber} from '../../helper/common'
import PerfectScrollbar from 'react-perfect-scrollbar'
import TableHeader from '../../components/control/table/table_header'
import TableCell from '../../components/control/table/table_cell'
import ReactPaginate from 'react-paginate'
import {PAGECOUNT} from '../../config/const'
import {rootStore} from '../../mobx/store'

const TicketList = observer((props) => {
  const context = useContext(Page_settings)
  let [dataList, setDataList] = useState([])
  let [pageCount, setPageCount] = useState(1)
  let [page, setPage] = useState(1)

  const active = 6;

  const tbHeaders = [
    {
      name: strings.num,
      class: 'w-10',
    },
    {
      name: strings.mb_lv,
      class: 'w-15',
    },
    {
      name: strings.analyst_member,
      class: 'w-20',
    },
    {
      name: strings.ticket_cnt1,
      class: 'w-55',
      divider: false
    },
  ]

  useEffect(() => {
    getData(1)
  }, [])

  const getData = (page) => {
    context.post('data/ticket_list', {page: page, count: PAGECOUNT},
      response => {
        let mb = rootStore.getMe
        mb.mb_point = response.mb_point
        rootStore.signIn(mb)
        setDataList(response.list)
        setPageCount(response.page_count)
      },
      false,
      err => {
        context.showAlert(err.msg)
      }
    )
  }

  const get_lv = (mb_lv) => {
    if (mb_lv == 2) return strings.analyst_winee
    if (mb_lv == 3) return strings.analyst_intern
    if (mb_lv == 4) return strings.wn_bj
    if (mb_lv == 5) return strings.best_bj
    if (mb_lv == 6) return strings.partner_bj
    return ''
  }

  const handlePageClick = (component) => {
    let nextPage = component.selected + 1
    setPage(nextPage)
    getData(nextPage)
  }

  return (
    <React.Fragment>
      <div className='content-container'>
        <SidebarLeft menu={MenuMy} active={active} history={props.history} />
        <div className='im-container'>
          <PageSubHeader pageName={strings.mypage} pageMenu1={strings.main} pageMenu2={strings.mypage} pageMenu={strings.ticket_list}/>
          <div className='term-content-area'>
            <div className='fs-20 sm-fs-16 f-b'>{strings.area}</div>
            <div className='shadow-div position-relative'>
              <PerfectScrollbar className='div_sale mt-30 sm-mt-20 mb-40'>
                <TableHeader className={'bg-white'} headers={tbHeaders}/>
                {
                  dataList.map((info, index) => {
                    return (
                      <div key={index} className='tb-row cursor-point'>
                        <TableCell
                          value={(page - 1) * PAGECOUNT + index + 1}
                          className={tbHeaders[0].class}
                          center={tbHeaders[0].center}
                          child={null}
                        />
                        <TableCell
                          value={get_lv(info.mb_lv)}
                          className={tbHeaders[1].class}
                          center={tbHeaders[1].center}
                          child={null}
                        />
                        <TableCell
                          value={info.mb_nick}
                          className={tbHeaders[2].class}
                          center={tbHeaders[2].center}
                          child={null}
                        />
                        <TableCell
                          value={formatNumber(info.ticket_cnt)}
                          className={tbHeaders[3].class}
                          center={tbHeaders[3].center}
                          child={null}
                        />
                      </div>
                    )
                  })
                }
              </PerfectScrollbar>
            </div>
            {pageCount > 1 &&
            <ReactPaginate
              previousLabel={''}
              nextLabel={''}
              breakLabel={'...'}
              breakClassName={'break-me'}
              pageCount={pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageClick}
              containerClassName={'pagination'}
              subContainerClassName={'pages pagination'}
              activeClassName={'active'}
            />
            }
          </div>
        </div>
      </div>
    </React.Fragment>
  )
})

export default withRouter(TicketList)
